export enum PortfolioType {
  Retail,
  Corporate
}
